import { Card, CardContent } from "../components/ui/card";
import { Link } from "react-router-dom";
import * as Icons from "lucide-react";

export const Datenschutz = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-gray-50 py-20">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          {/* Header */}
          <div className="text-center mb-12">
            <h1 className="text-4xl sm:text-5xl font-bold text-[#143e6e] mb-4">
              Datenschutzerklärung
            </h1>
            <p className="text-lg text-gray-600">
              Informationen zur Verarbeitung personenbezogener Daten
            </p>
          </div>

          {/* General Information */}
          <Card className="border-gray-200 shadow-lg mb-8">
            <CardContent className="p-8">
              <h2 className="text-2xl font-bold text-[#143e6e] mb-6 flex items-center">
                <Icons.Shield className="mr-3 text-[#1f7db6]" size={24} />
                1. Allgemeine Hinweise
              </h2>
              <div className="space-y-4 text-gray-700 leading-relaxed">
                <p>
                  Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können.
                </p>
                <p>
                  Ausführliche Informationen zum Thema Datenschutz entnehmen Sie unserer unter diesem Text aufgeführten Datenschutzerklärung.
                </p>
              </div>
            </CardContent>
          </Card>

          {/* Data Collection */}
          <Card className="border-gray-200 shadow-lg mb-8">
            <CardContent className="p-8">
              <h2 className="text-2xl font-bold text-[#143e6e] mb-6 flex items-center">
                <Icons.Database className="mr-3 text-[#1f7db6]" size={24} />
                2. Datenerfassung auf dieser Website
              </h2>
              
              <div className="space-y-6">
                <div>
                  <h3 className="text-xl font-semibold text-[#143e6e] mb-3">
                    Wer ist verantwortlich für die Datenerfassung auf dieser Website?
                  </h3>
                  <p className="text-gray-700 leading-relaxed">
                    Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten können Sie dem Abschnitt „Hinweis zur verantwortlichen Stelle" in dieser Datenschutzerklärung entnehmen.
                  </p>
                </div>

                <div>
                  <h3 className="text-xl font-semibold text-[#143e6e] mb-3">
                    Wie erfassen wir Ihre Daten?
                  </h3>
                  <p className="text-gray-700 leading-relaxed mb-3">
                    Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann es sich z.B. um Daten handeln, die Sie in ein Kontaktformular eingeben.
                  </p>
                  <p className="text-gray-700 leading-relaxed">
                    Andere Daten werden automatisch oder nach Ihrer Einwilligung beim Besuch der Website durch unsere IT-Systeme erfasst. Das sind vor allem technische Daten (z.B. Internetbrowser, Betriebssystem oder Uhrzeit des Seitenaufrufs).
                  </p>
                </div>

                <div>
                  <h3 className="text-xl font-semibold text-[#143e6e] mb-3">
                    Wofür nutzen wir Ihre Daten?
                  </h3>
                  <p className="text-gray-700 leading-relaxed">
                    Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der Website zu gewährleisten. Andere Daten können zur Analyse Ihres Nutzerverhaltens verwendet werden. Sofern Sie über unsere Website Anfragen stellen, verwenden wir Ihre Daten zur Bearbeitung Ihrer Anfrage.
                  </p>
                </div>

                <div>
                  <h3 className="text-xl font-semibold text-[#143e6e] mb-3">
                    Welche Rechte haben Sie bezüglich Ihrer Daten?
                  </h3>
                  <div className="text-gray-700 leading-relaxed space-y-2">
                    <p>Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft, Empfänger und Zweck Ihrer gespeicherten personenbezogenen Daten zu erhalten. Sie haben außerdem ein Recht, die Berichtigung oder Löschung dieser Daten zu verlangen.</p>
                    <p>Wenn Sie eine Einwilligung zur Datenverarbeitung erteilt haben, können Sie diese Einwilligung jederzeit für die Zukunft widerrufen. Außerdem haben Sie das Recht, unter bestimmten Umständen die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen.</p>
                    <p>Des Weiteren steht Ihnen ein Beschwerderecht bei der zuständigen Aufsichtsbehörde zu.</p>
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>

          {/* Responsible Party */}
          <Card className="border-gray-200 shadow-lg mb-8">
            <CardContent className="p-8">
              <h2 className="text-2xl font-bold text-[#143e6e] mb-6 flex items-center">
                <Icons.Building2 className="mr-3 text-[#1f7db6]" size={24} />
                3. Verantwortliche Stelle
              </h2>
              <div className="space-y-4 text-gray-700 leading-relaxed">
                <p>
                  Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:
                </p>
                <div className="bg-gray-50 p-6 rounded-lg">
                  <p className="font-semibold">ReTech IT GbR</p>
                  <p>Malik Vijahat Ahmad und Moran Roj Ismaiel</p>
                  <p className="mt-2">Goosmoortwiete 4</p>
                  <p>25474 Bönningstedt</p>
                  <p className="mt-3">
                    <span className="font-medium">Telefon:</span> <a href="tel:017663078464" className="text-[#1f7db6] hover:text-[#143e6e]">0176 63078464</a>
                  </p>
                  <p>
                    <span className="font-medium">E-Mail:</span> <a href="mailto:info@retech-it.de" className="text-[#1f7db6] hover:text-[#143e6e]">info@retech-it.de</a>
                  </p>
                </div>
                <p className="mt-4">
                  Verantwortliche Stelle ist die natürliche oder juristische Person, die allein oder gemeinsam mit anderen über die Zwecke und Mittel der Verarbeitung von personenbezogenen Daten (z.B. Namen, E-Mail-Adressen o. Ä.) entscheidet.
                </p>
              </div>
            </CardContent>
          </Card>

          {/* Contact Form */}
          <Card className="border-gray-200 shadow-lg mb-8">
            <CardContent className="p-8">
              <h2 className="text-2xl font-bold text-[#143e6e] mb-6 flex items-center">
                <Icons.Mail className="mr-3 text-[#1f7db6]" size={24} />
                4. Anfrage per Kontaktformular
              </h2>
              <div className="space-y-4 text-gray-700 leading-relaxed">
                <p>
                  Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert.
                </p>
                <p>
                  Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.
                </p>
                <p>
                  Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO, sofern Ihre Anfrage mit der Erfüllung eines Vertrags zusammenhängt oder zur Durchführung vorvertraglicher Maßnahmen erforderlich ist. In allen übrigen Fällen beruht die Verarbeitung auf unserem berechtigten Interesse an der effektiven Bearbeitung der an uns gerichteten Anfragen (Art. 6 Abs. 1 lit. f DSGVO) oder auf Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO) sofern diese abgefragt wurde.
                </p>
                <p>
                  Die von Ihnen im Kontaktformular eingegebenen Daten verbleiben bei uns, bis Sie uns zur Löschung auffordern, Ihre Einwilligung zur Speicherung widerrufen oder der Zweck für die Datenspeicherung entfällt (z.B. nach abgeschlossener Bearbeitung Ihrer Anfrage). Zwingende gesetzliche Bestimmungen – insbesondere Aufbewahrungsfristen – bleiben unberührt.
                </p>
              </div>
            </CardContent>
          </Card>

          {/* Your Rights */}
          <Card className="border-gray-200 shadow-lg mb-8">
            <CardContent className="p-8">
              <h2 className="text-2xl font-bold text-[#143e6e] mb-6 flex items-center">
                <Icons.FileText className="mr-3 text-[#1f7db6]" size={24} />
                5. Ihre Rechte
              </h2>
              <div className="space-y-4 text-gray-700 leading-relaxed">
                <div>
                  <h3 className="text-lg font-semibold text-[#143e6e] mb-2">Auskunftsrecht</h3>
                  <p>Sie haben das Recht, jederzeit Auskunft über die zu Ihrer Person gespeicherten Daten zu erhalten.</p>
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-[#143e6e] mb-2">Recht auf Berichtigung</h3>
                  <p>Sie haben das Recht, die Berichtigung unrichtiger oder die Vervollständigung unvollständiger personenbezogener Daten zu verlangen.</p>
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-[#143e6e] mb-2">Recht auf Löschung</h3>
                  <p>Sie haben das Recht, die Löschung Ihrer personenbezogenen Daten zu verlangen, sofern die gesetzlichen Voraussetzungen vorliegen.</p>
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-[#143e6e] mb-2">Recht auf Einschränkung der Verarbeitung</h3>
                  <p>Sie haben das Recht, die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen.</p>
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-[#143e6e] mb-2">Recht auf Datenübertragbarkeit</h3>
                  <p>Sie haben das Recht, die Sie betreffenden personenbezogenen Daten in einem strukturierten, gängigen und maschinenlesbaren Format zu erhalten.</p>
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-[#143e6e] mb-2">Widerspruchsrecht</h3>
                  <p>Sie haben das Recht, aus Gründen, die sich aus Ihrer besonderen Situation ergeben, jederzeit gegen die Verarbeitung Sie betreffender personenbezogener Daten Widerspruch einzulegen.</p>
                </div>
              </div>
            </CardContent>
          </Card>

          {/* SSL/TLS */}
          <Card className="border-gray-200 shadow-lg mb-8">
            <CardContent className="p-8">
              <h2 className="text-2xl font-bold text-[#143e6e] mb-6 flex items-center">
                <Icons.Lock className="mr-3 text-[#1f7db6]" size={24} />
                6. SSL- bzw. TLS-Verschlüsselung
              </h2>
              <div className="space-y-4 text-gray-700 leading-relaxed">
                <p>
                  Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher Inhalte, wie zum Beispiel Anfragen, die Sie an uns als Seitenbetreiber senden, eine SSL- bzw. TLS-Verschlüsselung.
                </p>
                <p>
                  Eine verschlüsselte Verbindung erkennen Sie daran, dass die Adresszeile des Browsers von „http://" auf „https://" wechselt und an dem Schloss-Symbol in Ihrer Browserzeile.
                </p>
                <p>
                  Wenn die SSL- bzw. TLS-Verschlüsselung aktiviert ist, können die Daten, die Sie an uns übermitteln, nicht von Dritten mitgelesen werden.
                </p>
              </div>
            </CardContent>
          </Card>

          {/* Contact for Privacy */}
          <Card className="border-gray-200 shadow-lg bg-blue-50">
            <CardContent className="p-8">
              <div className="flex items-start space-x-4">
                <div className="flex-shrink-0">
                  <div className="w-12 h-12 bg-[#1f7db6] rounded-full flex items-center justify-center">
                    <Icons.HelpCircle className="text-white" size={24} />
                  </div>
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-[#143e6e] mb-2">
                    Fragen zum Datenschutz?
                  </h3>
                  <p className="text-gray-700 leading-relaxed mb-3">
                    Wenn Sie Fragen zum Datenschutz haben, schreiben Sie uns bitte eine E-Mail oder wenden Sie sich direkt an die für den Datenschutz verantwortliche Person in unserer Organisation.
                  </p>
                  <p className="text-gray-700">
                    <span className="font-medium">E-Mail:</span>{" "}
                    <a 
                      href="mailto:info@retech-it.de" 
                      className="text-[#1f7db6] hover:text-[#143e6e] font-medium underline"
                    >
                      info@retech-it.de
                    </a>
                  </p>
                </div>
              </div>
            </CardContent>
          </Card>

          {/* Last Updated */}
          <div className="text-center mt-8 text-sm text-gray-600">
            <p>Stand: {new Date().toLocaleDateString('de-DE', { year: 'numeric', month: 'long' })}</p>
          </div>
        </div>
      </div>
    </div>
  );
};
